@if(isProfilePicture){
<input
  type="file"
  id="profilePicture"
  class="hidden-input"
  (change)="fileInput($any($event.target).files)"
  [accept]="state.supportedPhotoFileTypes.join(',')"
/>
}@else {
<input
  type="file"
  [attr.id]="uniqueId"
  class="hidden-input"
  (change)="fileInput($any($event.target).files)"
  [accept]="state.supportedFileTypes.join(',')"
  multiple
/>
} @if(files?.length > 0 && !autoUpload){
<div style="width: 100%; padding: 0 10px">
  Folgende Dokumente werden zu
  {{ displayName }} hochgeladen:
</div>
} @if(!autoUpload){
<div class="upload-section">
  @for (item of files; track item; let i = $index) {
  <div class="file-view">
    <ion-input
      labelPlacement="floating"
      fill="outline"
      mode="md"
      [(ngModel)]="item.displayName"
      [clearInput]="true"
      (ionChange)="this.mapFilesToRequests()"
    >
      <!--div slot="label">Dateiname</div-->
      @if (item.file != null) {
      <div slot="label">
        {{ tools.getDateString(item.file.lastModified) }} /
        {{ getFileSize(item.file.size) }} KB / {{ item.fileType }}
      </div>
      } @if (item.blob != null) {
      <div slot="label">
        {{ tools.getDateString(null) }} / {{ getFileSize(item.blob.size) }} KB /
        {{ item.fileType }}
      </div>
      }
    </ion-input>
    <ion-icon
      (click)="removeFile(i)"
      style="margin-left: 10px; font-size: 20px"
      class="red"
      name="trash-outline"
    ></ion-icon>
  </div>
  } @for (err of errors; track err) {
  <div class="warning red">
    {{ err }}
  </div>
  }
</div>
}
